<template>
  <div class="row card">
    <div class="col s12 m12 animated zoomIn">
      <h5>About US</h5>
      <p class="text-justify">
        iRecharge is an internet powered distribution platform that enables
        users purchase virtual products and services such as airtime and mobile
        data, internet subscriptions, pay TV, and Bulk SMS
      </p>
      <p class="text-justify">
        This solution which integrates seamlessly with all major Telecoms
        operators and service providers aims to provide value added services to
        consumers through as many access points as available.
      </p>
      <p class="text-justify">
        With instant transaction fulfillment and no need for pins or print outs,
        it's a quick and easy solution for airtime and subscriptions.
      </p>
      <p class="text-justify">
        Our Services and Solutions are designed to provide our customers with
        ultimate convenience…anywhere, anytime.
      </p>
      <p class="text-justify">
        <a
          href="https://play.google.com/store/apps/details?id=com.ist.irecharge&hl=en"
          target="_blank"
        >
          <img
            src="ui/img/playstore.png"
            alt="Play Store URL"
            style="margin-right: 15px; border-radius: 25px;"
            class="responsive-img animated tada delay-3s"
          />
        </a>
        <a
          href="https://itunes.apple.com/us/app/irecharge/id971084808?mt=8"
          target="_blank"
        >
          <img
            src="ui/img/ios.png"
            alt="Play Store URL"
            style="cursor: pointer; border-radius: 25px;"
            class="responsive-img animated tada delay-3s"
          />
        </a>
      </p>
      <h5>Connect With Us</h5>
      <div class="social-links d-flex justify-content-center">
        <a
          class="btn btn-social-icon"
          href="https://www.facebook.com/irechargeng"
          target="_blanck"
        >
          <i class="fa fa-facebook fa-lg"></i>
        </a>

        <a
          class="btn btn-social-icon"
          href="https://twitter.com/iRechargeNG"
          target="_blanck"
        >
          <i class="fa fa-twitter fa-lg"></i>
        </a>

        <a
          class="btn btn-social-icon"
          href="https://www.instagram.com/irechargeng/"
          target="_blanck"
        >
          <i class="fa fa-instagram fa-lg"></i>
        </a>

        <a class="btn btn-social-icon" href=" mailto:support@irecharge.com.ng">
          <i class="fa fa-envelope fa-lg"></i>
        </a>
      </div>
      <p class="text-center">
        <a href="tel:08149906336">
          <i class="fa fa-phone"></i> 0814 990 6336
        </a>
        <a href="tel:08070791433">
          , 0807 0791 433
        </a>
        <br />
        <span @click="whatsApp" style="cursor: pointer">
          <i class="fa fa-whatsapp"></i> 0903 000 9930
        </span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
  components: {},
  mounted() {
    $('.bills__side__wrapper').removeClass('left_out')
  },
  data() {
    return {}
  },
  methods: {
    whatsApp() {
      // window.open('https://api.whatsapp.com/send?phone=&text=Hello!%20I%27ve%20just%20made%20some%20transactions%20seamlessly%20right%20now.%20Try%20it%20out%20here,%20you%27ll%20enjoy%20their%20service%20https://irecharge.ng', '_blank');
      window.open(
        'https://api.whatsapp.com/send?phone=09030009930&text=How%20may%20we%20help%20you%20today%20',
        '_blank'
      )
    }
  }
}
</script>
<style scoped>
.social-links.d-flex.justify-content-center a.btn-social-icon {
  background-color: #fa6e36;
  margin: 0px 10px;
  border-radius: 0px;
}
.card {
  padding: 15px 20px;
}
</style>
